export type EmailDetails = {
  emailType: EmailType;
  emailTo: string[];
  from: string;
  replyTo: string;
  ccEmail: string[];
  bccEmail: string[];
  textBody: string;
  htmlBody: string;
  subject: string;
  uploadedFileUrl?: string;
  uploadedFileName?: string;
  action?: string;
  jobOrderId?: number;
  trainingOrderId?: number;
  jobOrderActions?: { jobOrderId: number; action: string }[];
};

export enum EmailType {
  EMAIL_TO_CREWING = "EMAIL_TO_CREWING",
  EMAIL_DOCUMENT_TO_MARINER = "EMAIL_DOCUMENT_TO_MARINER",
  EMAIL_TRAINING_CONTENT_TO_MARINER = "EMAIL_TRAINING_CONTENT_TO_MARINER",
  EMAIL_TRAINING_DOCUMENT_TO_MARINER = "EMAIL_TRAINING_DOCUMENT_TO_MARINER",
  EMAIL_TO_MARINER = "EMAIL_TO_MARINER",
  EMAIL_TO_TRAVEL_AGENT = "EMAIL_TO_TRAVEL_AGENT",
  EMAIL_TO_TRAVEL_AGENT_ROW = "EMAIL_TO_TRAVEL_AGENT_ROW",
  EVALUATION_ALERT = "EVALUATION_ALERT",
  EMAIL_TO_TRAVEL_AGENT_MULTI = "EMAIL_TO_TRAVEL_AGENT_MULTI",
}

export type AddressList = {
  travelAgentEmail: string;
  crewingEmail: string;
  trainingEmail?: string;
};

export enum TemplateType {
  BLANK = "BLANK",
  ARC_PRE_ARRIVAL = "ARC_PRE_ARRIVAL",
  MARLIN_PRE_ARRIVAL = "MARLIN_PRE_ARRIVAL",
  MARAD_PRE_ARRIVAL = "MARAD_PRE_ARRIVAL",
  ORCA_PRE_ARRIVAL = "ORCA_PRE_ARRIVAL",
  MARAD_LOCAL = "MARAD_LOCAL",
  MARAD_FOS = "MARAD_FOS",
  JAX_FLYING = "JAX_FLYING",
  JAX_LOCAL = "JAX_LOCAL",
  SAN_JUAN_FLYING = "SAN_JUAN_FLYING",
  SAN_JUAN_LOCAL = "SAN_JUAN_LOCAL",
  SEA_FLYING = "SEA_FLYING",
  SEA_LOCAL = "SEA_LOCAL",
  ANC_FLYING = "ANC_FLYING",
  ANC_LOCAL = "ANC_LOCAL",
  US_FLYING = "US_FLYING",
  US_LOCAL = "US_LOCAL",
  FOREIGN = "FOREIGN",
  TRAVEL_AGENT = "TRAVEL_AGENT",
  TRAVEL_AGENT_MULTI = "TRAVEL_AGENT_MULTI",
  PRE_ARRIVAL = "PRE_ARRIVAL",
  JOINING_INSTRUCTIONS = "JOINING_INSTRUCTIONS",
  EVALUATION_REMINDER = "EVALUATION_REMINDER",
  TRAINING_STAR_CENTER = "TRAINING_STAR_CENTER",
  TRAINING_LE_COMSEC_WEST = "TRAINING_LE_COMSEC_WEST",
  TRAINING_LE_COMSEC_EAST = "TRAINING_LE_COMSEC_EAST",
  TRAINING_LNG_FIRE_FIGHTING = "TRAINING_LNG_FIRE_FIGHTING",
  TRAINING_MECK = "TRAINING_MECK",
  TRAINING_ATO_AND_CBRD = "TRAINING_ATO_AND_CBRD",
}
export type EmailTemplate = {
  id: number;
  templateKey: string;
  displayName: string;
  emailType: string | null;
  subject: string;
  htmlBody: string;
  availableVars?: string;
  deleted: boolean;
};

export const TemplateTypeLabel: { [key in TemplateType]: string } = {
  [TemplateType.BLANK]: "Blank",
  [TemplateType.ARC_PRE_ARRIVAL]: "PRE-Arrival",
  [TemplateType.MARLIN_PRE_ARRIVAL]: "PRE-Arrival",
  [TemplateType.MARAD_PRE_ARRIVAL]: "PRE-Joining",
  [TemplateType.ORCA_PRE_ARRIVAL]: "PRE-Arrival",
  [TemplateType.MARAD_LOCAL]: "MARAD ROS Local Joining",
  [TemplateType.MARAD_FOS]: "MARAD FOS Travel",
  [TemplateType.JAX_FLYING]: "JAX Flying",
  [TemplateType.JAX_LOCAL]: "JAX Local",
  [TemplateType.SAN_JUAN_FLYING]: "SAN JUAN Flying",
  [TemplateType.SAN_JUAN_LOCAL]: "SAN JUAN Local",
  [TemplateType.SEA_FLYING]: "SEA Flying",
  [TemplateType.SEA_LOCAL]: "SEA Local",
  [TemplateType.ANC_FLYING]: "ANC Flying",
  [TemplateType.ANC_LOCAL]: "ANC Local",
  [TemplateType.US_FLYING]: "US Flying",
  [TemplateType.US_LOCAL]: "US Local",
  [TemplateType.FOREIGN]: "Foreign",
  [TemplateType.TRAVEL_AGENT]: "Travel Agent",
  [TemplateType.TRAVEL_AGENT_MULTI]: "Travel Agent Multi",
  [TemplateType.PRE_ARRIVAL]: "PRE-Arrival",
  [TemplateType.JOINING_INSTRUCTIONS]: "Joining Instructions",
  [TemplateType.EVALUATION_REMINDER]: "Evaluation Reminder",
  [TemplateType.TRAINING_STAR_CENTER]: "Star Center",
  [TemplateType.TRAINING_LE_COMSEC_WEST]: "LE COMSEC - West",
  [TemplateType.TRAINING_LE_COMSEC_EAST]: "LE COMSEC - East",
  [TemplateType.TRAINING_LNG_FIRE_FIGHTING]: "LNG Fire Fighting",
  [TemplateType.TRAINING_MECK]: "MECK",
  [TemplateType.TRAINING_ATO_AND_CBRD]: "ATO II and CBRD-O",
};
